<template>
  <div class="map-container">
    <div v-if="showMode">
      <div class="initStatus" @click="initStatus">初始状态</div>
      <div class="map-online">
        <div><span></span>在线船舶：{{ statusData.online }}</div>
        <div><span></span>离线船舶：{{ statusData.outline }}</div>
      </div>
      <div class="map-data">
        <div>区域分布</div>
        <div>
          <div v-for="(item, index) in regionData" :key="index">{{ item.key }}: {{ item.value }} </div>
        </div>
      </div>
    </div>
    <div id="mapWorld"></div>
  </div>
</template>

<script>
import east from '@/assets/boatEast.png';
import west from '@/assets/boatWest.png';
let map = null;
let T = null;
export default {
  // 组件名称
  name: 'MyMapComponent',
  // 数据
  data() {
    return {
      // 初始坐标
      initLngLat: {
        lng: 110.11489,
        lat: 31.03348
      },
      // 天地图
      minZoom: 6,
      maxZoom: 14,
      tk: 'c787199d4c6b3af5ec3c00b3210acd22',
      shipData: [
        {
          shipid: '12',
          shipname: '新长江06011',
          lastpost: '0',
          lat: '29.901009',
          lng: '113.62885',
          speed: '5.79',
          dir: '45.42',
          lEngineSpeed: '397.8',
          rEngineSpeed: '0.0',
          openStatus: null
        },
        {
          shipid: '16',
          shipname: '帝航1103',
          lastpost: '1670774400',
          lat: '30.806181',
          lng: '117.70036',
          speed: '0.0',
          dir: '114.1',
          lEngineSpeed: '0.0',
          rEngineSpeed: '0.0',
          openStatus: null
        },
        {
          shipid: '17',
          shipname: '淄柴1号',
          lastpost: '0',
          lat: '29.59675',
          lng: '106.59086',
          speed: '0.0',
          dir: '0.0',
          lEngineSpeed: '496.0',
          rEngineSpeed: '497.0',
          openStatus: null
        },
        {
          shipid: '20',
          shipname: '重轮集3017',
          lastpost: '0',
          lat: '29.296656',
          lng: '106.2568',
          speed: '10.63048',
          dir: '265.92',
          lEngineSpeed: '355.79999999999995',
          rEngineSpeed: '360.0',
          openStatus: null
        },
        {
          shipid: '21',
          shipname: '交通大学',
          lastpost: null,
          lat: '29.29',
          lng: '106.34',
          speed: '0.0',
          dir: '0.0',
          lEngineSpeed: '0.0',
          rEngineSpeed: '0.0',
          openStatus: null
        },
        {
          shipid: '23',
          shipname: '海装风电001',
          lastpost: null,
          lat: '31.69184684753418',
          lng: '121.80684661865234',
          speed: '0.0',
          dir: '243.10',
          lEngineSpeed: '0.0',
          rEngineSpeed: '0.0',
          openStatus: null
        }
      ],
      showMode: false,
      startTime: 0,
      timer: null,
      regionData: [],
      statusData: {},
      script: null
    };
  },
  // 生命周期函数
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    const scripts = document.head.querySelectorAll('script');
    scripts.forEach(script => {
      if (script.src.includes('http://api.tianditu.gov.cn')) {
        script.remove();
      }
    });
    this.script && this.script.parentNode.removeChild(this.script);
  },
  // 计算属性
  computed: {},
  // 方法
  methods: {
    async initMap() {
      this.loadMapJScript();
    },
    loadMapJScript() {
      this.script = document.createElement('script');
      const script = this.script;
      script.type = 'text/javascript';
      script.src = `http://api.tianditu.gov.cn/api?v=4.0&tk=${this.tk}`;
      script.onload = () => {
        T = window.T;
        map = new T.Map('mapWorld'); // 地图窗口
        const { initLngLat, minZoom } = this;
        let control;
        let scale;
        // 天地图
        map.centerAndZoom(new T.LngLat(initLngLat.lng, initLngLat.lat), minZoom);
        // 创建缩放平移控件对象
        control = new T.Control.Zoom();
        // 添加缩放平移控件
        map.addControl(control);
        // 创建比例尺控件对象
        scale = new T.Control.Scale();
        // 添加比例尺控件
        map.addControl(scale);

        this.showMode = true;

        this.createShipImg();
      };
      document.body.appendChild(script);
    },
    initStatus() {
      if (Date.now() - this.startTime <= 500) {
        return;
      }
      this.startTime = Date.now();
      map.panTo(new T.LngLat(this.initLngLat.lng, this.initLngLat.lat), this.minZoom);
    },
    async createShipImg() {
      if (this.shipData.length === 0) {
        return;
      }
      const imgSize = 35;

      // 清除图层
      map.clearOverLays();

      const regionMap = new Map();
      const statusData = {
        online: 0,
        outline: 0
      };

      for (let index = 0; index < this.shipData.length; index++) {
        const item = this.shipData[index];

        if (!item.lng) item.lng = 63;
        if (!item.lat) item.lat = 13;

        const iconUrl = item.dir > 180 ? west : east;

        const icon = new T.Icon({
          iconUrl: iconUrl,
          iconSize: new T.Point(imgSize, imgSize),
          iconAnchor: new T.Point(imgSize / 2, imgSize / 2)
        });

        // 向地图上添加自定义标注
        const marker = new T.Marker(new T.LngLat(item.lng, item.lat), { icon: icon });
        map.addOverLay(marker);

        // 标注事件
        marker.addEventListener('click', async e => {
          await this.showInfo(e.lnglat, marker, item);
        });

        index === 0 && (await this.showInfo(marker.getLngLat(), marker, item));

        const { province } = await this.getAddressFromLatLng(marker.getLngLat());

        if (province) {
          let value = 1;
          if (regionMap.has(province)) {
            value = regionMap.get(province);
            regionMap.set(province, ++value);
          } else {
            regionMap.set(province, value);
          }
        }

        if (item.speed > 0) {
          statusData.online = statusData.online + 1;
        } else {
          statusData.outline = statusData.outline + 1;
        }
      }
      let regionData = [];
      regionMap.forEach((value, key) => {
        regionData.push({ id: key, key: key, value: value });
      });
      this.regionData = regionData;
      this.statusData = statusData;
    },
    async showInfo(lnglat, marker, item) {
      let infoWin;

      // 关闭信息窗口
      map.closeInfoWindow();

      // 地址逆解析
      const { address } = await this.getAddressFromLatLng(lnglat);

      const hiddenShip = item.shipid === '4' ? 'hiddenShip' : '';
      const sContent = `
        <div id='infoBox'>
          <h2 class='shipName'>${item.shipname}<span class='${hiddenShip}'>（${item.speed > 0 ? '航行' : '停泊'}）</span></h2>
          <div class='shipInfo'>
            <div>位置：${address}</div>
            <div class='${hiddenShip}'>航速：${item.speed ? parseFloat(item.speed).toFixed(2) : '0.0'} km/h</div>
            <div class='${hiddenShip}'>航向：${item.dir ? item.dir : '0.0'} (${item.dir > 180 ? '上行' : '下行'})</div>
            <div>
              <button id='shipMain'>报警详情</button>
            </div>
          </div>
        </div>
      `;

      // 创建信息窗口
      infoWin = new T.InfoWindow(sContent);
      await marker.openInfoWindow(infoWin);
      setTimeout(async () => {
        // await this.infoWindowEvent(lnglat, address, item);
      }, 500);
    },
    async getAddressFromLatLng(lnglat) {
      const geocode = new T.Geocoder();
      const hint = '无';
      try {
        const result = await new Promise((resolve, reject) => {
          geocode.getLocation(lnglat, resolve, reject);
        });
        let address = await result.getAddress();
        // eslint-disable-next-line no-irregular-whitespace
        address = address && address.replace(/　　　　/g, ' ');
        return {
          address: (await result.getStatus()) === 0 ? address || hint : hint,
          province: result.addressComponent.province
        };
      } catch (error) {
        console.error('获取地址失败:', error);
        return {
          address: hint,
          province: ''
        };
      }
    },
    infoWindowEvent(lnglat, address, item) {
      console.log(lnglat, address, item);
    }
  },
  // 组件
  components: {},
  // 自定义属性
  props: {}
};
</script>

<style>
.map-container {
  width: 100%;
  height: calc(100vh - 120px);
  position: relative;
}
.initStatus {
  position: absolute;
  top: 20px;
  left: 10px;
  z-index: 10000;
  border: 1px solid #000;
  padding: 5px 8px;
  background-color: #fff;
  cursor: pointer;
  letter-spacing: 1px;
  border-radius: 2px;
  font-size: 12px;
  &:hover {
    background-color: #f4f4f4;
  }
}

#mapWorld {
  width: 100%;
  height: 100%;
  .tdt-infowindow-content {
    margin: 0;
    line-height: 1.1;
  }
  .tdt-infowindow-content-wrapper {
    color: #fff;
    padding: 0;
    border-radius: 10px;
    background: #ffffff00;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
  }
  .tdt-map-pane .tdt-infowindow {
    opacity: 0.9 !important;
  }
  .tdt-top {
    top: 60px;
  }
  .tdt-control-copyright {
    display: none !important;
  }
}

#infoBox {
  max-width: 250px;
  user-select: none;
  border-radius: 10px;
  background: url(~@/assets/infoBox_bg.jpg) no-repeat;
  background-size: 100% 100%;
  .shipName {
    text-align: center;
    margin: 0 0 8px 0;
    padding: 14px 0 10px 0;
    background: #0078d3;
    border-bottom: 2px solid #a7a7a7;
    border-radius: 10px 10px 0 0;
  }
  .shipInfo {
    padding: 0 20px;
    div:nth-of-type(1) {
      font-size: 19px;
    }
    div:nth-of-type(2) {
      font-size: 16px;
      margin-top: 3px;
    }
    div:nth-of-type(3) {
      font-size: 16px;
      margin: 5px 0 3px 0;
    }
    div:nth-of-type(4) {
      padding: 9px 0;
      display: flex;
      justify-content: space-around;
      button {
        cursor: pointer;
        background-color: bisque;
      }
    }
  }
  .hiddenShip {
    display: none;
  }
}
.map-online {
  position: absolute;
  bottom: 0px;
  left: 110px;
  color: #006aff;
  z-index: 1000;
  cursor: default;
}
.map-online > div {
  padding: 3px;
}
.map-online > div:nth-of-type(1) span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  background-color: green;
}
.map-online > div:nth-of-type(2) span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  background-color: #ff0000;
}
.map-data {
  cursor: default;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  padding: 20px;
  background-color: #1d40685e;
  color: #006aff;
  letter-spacing: 2px;
  border-radius: 5px;
  z-index: 1000;
}
.map-data > div:first-child {
  writing-mode: vertical-lr;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shipPosition.vue